<template>
  <div id="logo-aplication">
    <b-img
        class="logo"
        src="/logo-salesflow.png"
        :alt="altImg"
        :width="widthImg"
        :height="heightImg"
        :class="classImg"
        :sizes="sizesImg"
        @click="navigate"
        style="cursor: pointer;"
    />
  </div>
</template>

<script>

export default {
  name: 'LogoApp',
  props: {
    value: {
      type: String,
      default: () => 'favicon.svg',
    },
    altImg: {
      type: String,
      default: 'logo',
    },
    widthImg: {
      type: String,
      default: 'auto',
    },
    heightImg: {
      type: String,
      default: 'auto',
    },
    classImg: {
      type: String,
      default: '',
    },
    sizesImg: {
      type: String,
      default: '',
    },
  },
  computed: {
    appLogoImage: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    navigate() {
      this.$router.push('/home');
    },
  },
};
</script>

<style scoped lang="scss">
#logo-aplication {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  margin-top: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 2px 8px rgba(102, 126, 234, 0.3));

  &:hover {
    filter: drop-shadow(0 4px 12px rgba(0, 212, 255, 0.4));
    transform: scale(1.02);
  }
}

.logo-transition {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}
</style>
